import { render, staticRenderFns } from "./ViewerUnauthorised.vue?vue&type=template&id=7d6f1f7e&scoped=true&"
import script from "./ViewerUnauthorised.vue?vue&type=script&lang=js&"
export * from "./ViewerUnauthorised.vue?vue&type=script&lang=js&"
import style0 from "./ViewerUnauthorised.vue?vue&type=style&index=0&id=7d6f1f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6f1f7e",
  null
  
)

export default component.exports